import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, of, Subject } from 'rxjs';
import Swal from 'sweetalert2';
import { environment } from '../../../../../../../../environments/environment';
import { ChargesWithdrawalsRequestService } from '../../../../../../../core/services/charges-withdrawals-request.service';
import { DynamicModalService } from '../../../../../../../core/services/dynamic-modal.service';
import { FinancialService } from '../../../../../../../core/services/financial.service';
import { HolderAccountBankService } from '../../../../../../../core/services/holder-account-bank.service';
import { selectAuth } from '../../../../../../../core/state/auth/auth.selector';
import {
  ROLES,
  USER_TYPES,
} from '../../../../../../../shared/data/config/constants';
import {
  REQUEST_STATUS,
  REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS,
} from '../../../../../../../shared/data/config/constants-buttons';
import {
  ACCOUNT_TYPES,
  ACCOUNT_TYPES_TEXT,
  ALERTS_TYPES,
  ALLOWED_TYPES_FOR_AGENT_PLAYER,
  ALLOWED_TYPES_FOR_AGENT_READONLY,
  ALLOWED_TYPES_FOR_AGENT_READONLY_SPECIAL,
  ALLOWED_TYPES_FOR_BANK,
  ALLOWED_TYPES_FOR_BENEFICIARY,
  ALLOWED_TYPES_FOR_CHECK_RECEIPT,
  ALLOWED_TYPES_FOR_HOLDER_BY_EDIT,
  ALLOWED_TYPES_FOR_IDENTIFICATION,
  ALLOWED_TYPES_FOR_MONTO,
  ALLOWED_TYPES_FOR_MONTO_BANK_ID_ACCOUNT,
  ALLOWED_TYPES_FOR_MONTO_BANK_RECEIPT,
  ALLOWED_TYPES_FOR_PENDING_PREVALIDATION,
  ALLOWED_TYPES_FOR_PLAYER_READONLY,
  ALLOWED_TYPES_FOR_PLAYER_READONLY_SPECIAL,
  ALLOWED_TYPES_FOR_RECEIPT,
  ALLOWED_TYPES_FOR_STATUS_RISKY_RECEIPT,
  ALLOWED_TYPES_FOR_UPLOAD_WITHDRAWAL_DIRECT,
  DEFAULT_VALUE,
  ERROR_MESSAGES,
  INTERBANK_TRANSDFER_OPTIONS,
  INTERBANK_TRANSDFER_OPTIONS_VALUES,
  IS_CROSS_REQUEST,
  NULL_VALUE_TEXT,
  PAGE_SIZE_VALUE,
  PROCESSING_TEXT,
  STATE_NAMES,
  TRANSACTION_TYPE_VALUES,
  TRANSACTION_TYPES,
  TRUE_CHECK_VALUE,
  UNKNOWN_VALUE_TEXT,
  WITHDRAWAL_RECEIPT_LOCK,
} from '../../../../../../../shared/data/suscriptions-payments/constants';
import { ImageCompressionService } from '../../../../../../../shared/services/image-compression.service';
import { UserMainService } from '../../../../../../user/services/user-main.service';
import moment from 'moment-timezone';
import { AlertService } from '../../../../../../../shared/services/alert.service';
import { OcrService } from '../../../../../../../core/services/api/ocr.service';
import { BankData, OcrResponse } from '../../../../../../../core/interfaces/ui/ocr.interface';
import { showOcrPartialWarning } from '../../../../../../../core/utils/ocr-warning.util';
import { BankMatcherService } from '../../../../../../../core/services/ui/bank-matcher.service';
import { REQUEST_WITHDRAWAL_PERMISSIONS } from '../../../../../../../shared/data/config/constants-buttons';
import {
  ALLOW_KEYS,
  DEFAULT_ATTEMPS,
  DETAIL_NORMALIZE,
  DUPLICATE_VOUCHER_REJECT_REASON,
  GENERAL_STATUS,
  GENERIC_LABELS,
  NON_NAME_KEYWORDS,
} from '../../../../../../../core/constants/constants';
import { extractErrorMessage } from '../../../../../../../core/utils/extract-error-message.util';
import { RepeatedVoucherActionModalComponent } from '../repeated-voucher-action-modal/repeated-voucher-action-modal.component';

const REPEATED_VOUCHER_ERROR_CODE = 'REPEATED_VOUCHER_CONFIRMATION_REQUIRED';

interface Alert {
  type: string;
  message: string;
}

interface FilePreview {
  file: File;
  previewVisible: boolean;
  urlFile: string;
}

@Component({
  selector: 'app-edit-cw-request',
  templateUrl: './edit-cw-request.component.html',
  styleUrl: './edit-cw-request.component.scss',
})
export class EditCwRequestComponent implements OnInit {
  public cw_id: number = 0;
  public cwData: any;
  public cwEditForm!: FormGroup;
  public id_country!: number;
  public optionsBanks$: any;
  public optionsHolder$: any;
  public optionsInterbankTransfer$: any;
  public transformedDataBank: any;
  public selectedBankId!: number;
  public allHoldersData: any[] = [];
  public allClientBankData: any[] = [];
  public allEnterpriseBankData: any[] = [];
  public selectedAccountNumber: any[] = [];
  public currentPageHolders = 1;
  public currentPageBanks = 1;
  public pageSize = 10;
  public criteria: any;
  public receipVoucher: any;
  public reciptError: boolean = false;
  public isManual = false;
  public inappropiatedComment: any;
  public profile$ = this.store.select(selectAuth);
  public profile: any;
  public tipo_usuario: any;
  public rol!: number;
  public alloweEnterprise: boolean = false;
  public transfer_Type: any;
  public isLoading: boolean = true;
  public isLoadingButton = false;
  public transactionLabel: string = '';
  public transferLabel: string = '';
  public blackList: boolean = false;
  public entityType: string = '';
  public isAgent = true;
  public isFileRequired: boolean = false;
  public roles = ROLES;
  public userType = USER_TYPES;
  private holderSubject: Subject<string> = new Subject<string>();
  public isSaving: boolean = true;
  public accountTypeLabel: string = 'Ahorros';
  public isRiskyTicket: boolean = true;
  public DEFAULT_VALUE = DEFAULT_VALUE;
  private updatingValidators: boolean = false;
  public isBackofficePlayer: boolean = false;

  //ALERTS
  public alerts: Alert[] = [];

  //IMG
  public previewImage: any;
  public selectedFiles: FilePreview[] = [];
  public imgSrc!: any;
  public urlResponse: any;
  public file: any;
  public baseUrl: string = environment.API_FILES;
  public idBank: any;
  public idBankEnterprise: any;
  public transferInterbankId: any;
  public recipt: any;
  public data: any;
  public originalReceiptImage: string = '';
  public player: string = '';
  public agent: string = '';
  @ViewChild('fileInput') fileInput!: ElementRef;
  public TRANSACTION_TYPE_VALUES = TRANSACTION_TYPE_VALUES;
  public WITHDRAWAL_RECEIPT_LOCK = WITHDRAWAL_RECEIPT_LOCK;
  public ALLOWED_TYPES_FOR_BANK = ALLOWED_TYPES_FOR_BANK;
  public ALLOWED_TYPES_FOR_AGENT_READONLY = ALLOWED_TYPES_FOR_AGENT_READONLY;
  public ALLOWED_TYPES_FOR_PLAYER_READONLY = ALLOWED_TYPES_FOR_PLAYER_READONLY;
  public ALLOWED_TYPES_FOR_AGENT_READONLY_SPECIAL =
    ALLOWED_TYPES_FOR_AGENT_READONLY_SPECIAL;
  public ALLOWED_TYPES_FOR_PLAYER_READONLY_SPECIAL =
    ALLOWED_TYPES_FOR_PLAYER_READONLY_SPECIAL;
  public ALLOWED_TYPES_FOR_AGENT_PLAYER = ALLOWED_TYPES_FOR_AGENT_PLAYER;
  public ALLOWED_TYPES_FOR_HOLDER_BY_EDIT = ALLOWED_TYPES_FOR_HOLDER_BY_EDIT;
  public ALLOWED_TYPES_FOR_RECEIPT = ALLOWED_TYPES_FOR_RECEIPT;
  public ALLOWED_TYPES_FOR_IDENTIFICATION = ALLOWED_TYPES_FOR_IDENTIFICATION;
  public ALLOWED_TYPES_FOR_BENEFICIARY = ALLOWED_TYPES_FOR_BENEFICIARY;
  public ALLOWED_TYPES_FOR_CHECK_RECEIPT = ALLOWED_TYPES_FOR_CHECK_RECEIPT;
  public ALLOWED_TYPES_FOR_UPLOAD_WITHDRAWAL_DIRECT =
    ALLOWED_TYPES_FOR_UPLOAD_WITHDRAWAL_DIRECT;
  public ALLOWED_TYPES_FOR_STATUS_RISKY_RECEIPT =
    ALLOWED_TYPES_FOR_STATUS_RISKY_RECEIPT;
  public ALLOWED_TYPES_FOR_MONTO = ALLOWED_TYPES_FOR_MONTO;
  public ALLOWED_TYPES_FOR_MONTO_BANK_ID_ACCOUNT =
    ALLOWED_TYPES_FOR_MONTO_BANK_ID_ACCOUNT;
  public ALLOWED_TYPES_FOR_MONTO_BANK_RECEIPT =
    ALLOWED_TYPES_FOR_MONTO_BANK_RECEIPT;
  public identificationError: boolean = false;
  public numberAccountError: boolean = false;
  private isOcrAutoFilling: boolean = false;
  private lastResolvedHolderBankId: number | null = null;
  public activeOcrProvider: 'gemini' | 'ollama' = 'gemini';

  constructor(
    private _dynamicModal: DynamicModalService,
    private _cwService: ChargesWithdrawalsRequestService,
    private _userMainService: UserMainService,
    private _financialService: FinancialService,
    private _holderAccountBank: HolderAccountBankService,
    private store: Store,
    private _toastrSvc: ToastrService,
    private fb: FormBuilder,
    private ocrService: OcrService,
    private _bankMatcher: BankMatcherService,
    private sanitizer: DomSanitizer,
    private activeModal: NgbActiveModal,
    private _imageCompressionService: ImageCompressionService,
    private alertService: AlertService,
  ) {
    this.initForm();
    this.holderSubject.pipe(debounceTime(400)).subscribe(async (term) => {
      this.allHoldersData = [];
      this.allEnterpriseBankData = [];
      this.allClientBankData = [];
      await this.loadHolders(term);
      this.getBankData(term);
    });
  }

  ngOnInit(): void {
    this.data = this._dynamicModal.getModalData();
    this.getCwData();
    this.loadTypeTransfer();
    this.validatorsReciptImg();
    const isManualFromStorage = localStorage.getItem('isManual');
    this.isManual = isManualFromStorage === 'true';
    this.loadActiveOcrProvider();
  }

  private loadActiveOcrProvider(): void {
    this.ocrService.getActiveProvider().subscribe({
      next: (res) => {
        if (res?.data?.provider === 'ollama') {
          this.activeOcrProvider = 'ollama';
        }
      },
    });
  }

  //? LOAD DATA
  getCwData() {
    this.isLoading = true;
    this._cwService.getCw(this.data.id).subscribe(async (response) => {
      this.cwData = response.data;
      this.id_country = this.cwData.id_pais;
      if (this.id_country) {
        this.getBankData();
      }
      if (
        this.cwData.jugador_white_list?.lista_negra === 1 ||
        this.cwData.agente_white_list?.lista_negra === 1
      ) {
        this.blackList = true;
      }

      this.player = this.cwData.player;
      this.agent = this.cwData.agent;
      this.reciptError = false;
      this.idBank = this.cwData.id_banco;
      this.idBankEnterprise = this.cwData.id_banco_empresa;
      this.recipt = this.cwData.foto_comprobante;
      this.originalReceiptImage = this.cwData.foto_comprobante || '';
      this.cwEditForm.patchValue({
        monto: Number(this.cwData.monto),
        ...this.cwData,
      });

      if (this.cwData.id_jugador) {
        this.entityType = 'jugador';
        if (this.cwData.player_remote_id) {
          this.isBackofficePlayer = true;
        } else {
          this.isBackofficePlayer = false;
        }
      } else if (this.cwData.id_agente) {
        this.entityType = 'agente';
      }
      if (this.cwData.tipo_cuenta === ACCOUNT_TYPES.CURRENT) {
        this.isSaving = false;
        this.accountTypeLabel = ACCOUNT_TYPES_TEXT.CURRENT;
      } else {
        this.isSaving = true;
        this.accountTypeLabel = ACCOUNT_TYPES_TEXT.SAVINGS;
      }
      const transactionType = TRANSACTION_TYPES.find(
        (type) => type.value === this.cwData.tipo_transaccion.toString(),
      );
      this.transactionLabel = transactionType
        ? transactionType.label
        : UNKNOWN_VALUE_TEXT;
      if (this.cwData.transferencia_interbancaria !== null) {
        this.cwEditForm
          .get('transferencia_interbancaria')
          ?.setValue(this.cwData.transferencia_interbancaria.toString());
      }
      if (this.cwData.foto_comprobante) {
        this.previewImage = this.formatUrl(this.cwData.foto_comprobante);
      } else {
        this.previewImage = null;
      }
      if (
        this.cwData.comprobante === NULL_VALUE_TEXT ||
        this.cwData.comprobante_empresa === NULL_VALUE_TEXT
      ) {
        this.cwEditForm.get('comprobante')?.setValue('');
        this.cwEditForm.get('comprobante_empresa')?.setValue('');
      }
      if (this.cwData.banco?.idabpa_banco !== null) {
        this.cwEditForm
          .get('id_banco')
          ?.setValue(this.cwData.banco?.idabpa_banco);
      }
      if (this.cwData.id_banco_empresa === DEFAULT_VALUE) {
        this.cwEditForm.get('id_banco_empresa')?.setValue(null);
      } else if (this.cwData.id_banco_empresa !== null) {
        this.cwEditForm
          .get('id_banco_empresa')
          ?.setValue(this.cwData.id_banco_empresa);
      }
      if (this.cwData.detalle === NULL_VALUE_TEXT) {
        this.cwEditForm.get('detalle')?.setValue('');
      }
      if (this.cwData.nombre_titular === NULL_VALUE_TEXT) {
        this.cwEditForm.get('nombre_titular')?.setValue('');
      }
      if (
        [
          TRANSACTION_TYPE_VALUES.LOAD_BALANCE,
          TRANSACTION_TYPE_VALUES.WITHDRAW_BALANCE,
          TRANSACTION_TYPE_VALUES.LOAD_BONUS_BALANCE,
          TRANSACTION_TYPE_VALUES.PAY_TO_DEBIT,
          TRANSACTION_TYPE_VALUES.COLLECT_COMMISSION,
          TRANSACTION_TYPE_VALUES.FINANCIAL,
          TRANSACTION_TYPE_VALUES.CREDIT_WITHDRAWAL,
        ].includes(this.cwData.tipo_transaccion)
      ) {
        this.cwEditForm.get('cargar_retirar_directo')?.disable();
      }
      this.isLoading = false;
      if (this.idBank) {
        if (
          [
            Number(INTERBANK_TRANSDFER_OPTIONS_VALUES.YES),
            Number(INTERBANK_TRANSDFER_OPTIONS_VALUES.OTHERS),
          ].includes(this.cwData.transferencia_interbancaria)
        ) {
          this.selectedBankId = this.idBankEnterprise;
        } else {
          this.selectedBankId = this.idBank;
        }

        await this.loadHolders();

        if (
          this.cwData.id_titular &&
          this.cwData.id_titular !== DEFAULT_VALUE
        ) {
          const holderExists = this.allHoldersData.find(
            (h) => h.value === this.cwData.id_titular,
          );

          if (!holderExists) {
            const accountNumber =
              this.cwData.account_number?.account_number || 'N/A';
            const holderName = this.cwData.holder?.usuario || 'Titular Actual';
            const bankName = this.cwData.banco?.banco || 'Banco';

            const currentHolder = {
              label: `${holderName} (${bankName} - ${accountNumber})`,
              value: this.cwData.id_titular,
            };

            this.allHoldersData.unshift(currentHolder);
            this.optionsHolder$ = of(this.allHoldersData);
          }
        }
      }
      this.toggleTitularControl();

      if (this.cwData.id_titular === DEFAULT_VALUE) {
        this.cwEditForm.get('id_titular')?.setValue(null);
      } else {
        this.cwEditForm.get('id_titular')?.setValue(this.cwData.id_titular);
      }

      if (this.data?.readOnly) {
        Object.keys(this.cwEditForm.controls).forEach((key) => {
          this.cwEditForm.get(key)?.disable({ emitEvent: false });
        });
      }
    });
    this.isRiskyTicket =
      this.cwData?.estado_boleta_riesgosa === TRUE_CHECK_VALUE;
  }

  getBankData(searchTerm?: string) {
    this._userMainService
      .getAllBanksBySelect(
        this.currentPageBanks,
        this.pageSize,
        searchTerm,
        this.id_country,
      )
      .subscribe((response) => {
        this.transformedDataBank = response.data.map((item) => {
          return { label: item.bankName, value: item.bankId };
        });
        this.allEnterpriseBankData = [
          ...this.allEnterpriseBankData,
          ...this.transformedDataBank,
        ];
        this.allClientBankData = [
          ...this.allClientBankData,
          ...this.transformedDataBank,
        ];
      });
  }

  async loadHolders(searchTerm?: string) {
    await new Promise((resolve, reject) =>
      this._holderAccountBank
        .getAllHoldersAccountData(
          this.currentPageHolders,
          this.pageSize,
          this.id_country,
          this.selectedBankId,
          searchTerm,
        )
        .subscribe(
          (res) => {
            const response = res.data;

            const transformedData = response.data.map((item: any) => {
              return {
                label:
                  item.holder +
                  ' (' +
                  item.bank +
                  ' - ' +
                  item.account_number +
                  ')',
                value: item.id_usuario,
              };
            });

            this.optionsHolder$ = of(transformedData);
            this.allHoldersData = [...this.allHoldersData, ...transformedData];
            resolve(null);
          },
          (err) => reject(err),
        ),
    );
  }

  loadTypeTransfer() {
    this.optionsInterbankTransfer$ = of(INTERBANK_TRANSDFER_OPTIONS);
    this.cwEditForm
      .get('transferencia_interbancaria')
      ?.setValue(INTERBANK_TRANSDFER_OPTIONS_VALUES.NO.toString());
  }

  loadProfileLogged() {
    this.profile$.subscribe((profile) => {
      if (profile.idusuario) {
        this.profile = profile;
        this.tipo_usuario = this.profile.tipo_usuario.toString();
        this.rol = this.profile.id_rol;
      }
    });
  }

  //?MODAL
  closeModal() {
    this.activeModal.close();
    this.cwEditForm.reset();
  }

  approveATC() {
    this.alertService
      .showConfirmAlert(
        '¿Aprobar revisión ATC?',
        'El retiro pasará a estado Procesado.',
        'Sí, aprobar',
        'Cancelar',
      )
      .then((result) => {
        if (!result.isConfirmed) return;
        this._cwService
          .setState(this.cwData.id, REQUEST_STATUS.PROCESSED, this.profile.idusuario)
          .subscribe({
            next: () => {
              this._toastrSvc.success('Aprobado');
              this.activeModal.close({ refresh: true });
            },
          });
      });
  }

  openRejectFlow() {
    this.alertService
      .showInputAlert(
        'Escribe el motivo del rechazo',
        'Motivo',
        'Escribe aquí...',
        'Enviar motivo',
        'Cancelar',
        (value) => (value?.trim() ? null : 'El motivo es obligatorio'),
      )
      .then((textResult) => {
        if (!textResult.isConfirmed || !textResult.value?.trim()) return;
        this._cwService
          .setState(this.cwData.id, REQUEST_STATUS.REJECTED, this.profile.idusuario, textResult.value)
          .subscribe({
            next: () => {
              this._toastrSvc.success('Rechazado');
              this.activeModal.close({ refresh: true });
            },
          });
      });
  }

  //? PREVALIDATION
  canPrevalidateRequest(): boolean {
    if (this.data?.readOnly || this.isLoading) return false;

    if (
      !this.hasPermission(
        REQUEST_WITHDRAWAL_BUTTON_PERMISSIONS.PREVALIDATED_PROCESSED,
      )
    ) {
      return false;
    }

    const currentState = Number(this.cwData?.estado);

    if (currentState === REQUEST_STATUS.PROCESSED) return true;

    if (currentState !== REQUEST_STATUS.PENDING) return false;

    // Mismas reglas que el botón del listado: en pendiente sólo los tipos
    // habilitados o las solicitudes cruzadas pueden prevalidarse directo.
    return (
      this.isTransactionTypeAllowed(
        this.cwData?.tipo_transaccion,
        ALLOWED_TYPES_FOR_PENDING_PREVALIDATION,
      ) || Number(this.cwData?.solicitud_cruzada) === IS_CROSS_REQUEST
    );
  }

  prevalidateRequest(): void {
    this.alertService
      .showConfirmAlert(
        '¿Prevalidar la solicitud?',
        'Se guardarán los cambios del formulario y la solicitud pasará a Procesado Prevalidado. No podrás revertir esto!',
        'Sí, prevalidar!',
        'Cancelar',
      )
      .then((result) => {
        if (!result.isConfirmed) return;
        this.onSubmit(() => this.applyPrevalidatedState());
      });
  }

  private applyPrevalidatedState(allowRepeatedVoucher = false): void {
    this._cwService
      .setState(
        this.data.id,
        STATE_NAMES.PREVALIDATED_PROCESSED,
        this.profile.idusuario,
        undefined,
        undefined,
        allowRepeatedVoucher,
      )
      .subscribe({
        next: () => {
          this.isLoadingButton = false;
          this._toastrSvc.success('Solicitud prevalidada correctamente!');
          this.closeModal();
        },
        error: (error: HttpErrorResponse) => {
          this.isLoadingButton = false;
          this.confirmRepeatedVoucherPrevalidation(error);
          // El http-error.interceptor muestra el toast con el mensaje del backend.
          // El modal queda abierto para poder reintentar la prevalidación.
        },
      });
  }

  private confirmRepeatedVoucherPrevalidation(error: HttpErrorResponse): void {
    const errorCode = error?.error?.code || error?.error?.data?.code;

    if (errorCode !== REPEATED_VOUCHER_ERROR_CODE) return;

    const message = extractErrorMessage(
      error,
      'es',
      'Se detectó un comprobante repetido. ¿Deseas continuar de todos modos?',
    );

    const modalRef = this._dynamicModal.openModal(
      RepeatedVoucherActionModalComponent,
      'Comprobante repetido',
      'md',
      true,
      { message },
    );

    modalRef.result.then((result: { action?: string }) => {
      if (result?.action === 'continue') {
        this.isLoadingButton = true;
        this.applyPrevalidatedState(true);
        return;
      }

      if (result?.action === 'reject') {
        this.rejectForRepeatedVoucher();
      }
    }, () => {});
  }

  private rejectForRepeatedVoucher(): void {
    this.isLoadingButton = true;
    this._cwService
      .setState(
        this.data.id,
        STATE_NAMES.REJECTED,
        this.profile.idusuario,
        DUPLICATE_VOUCHER_REJECT_REASON,
      )
      .subscribe({
        next: () => {
          this.isLoadingButton = false;
          this._toastrSvc.success(
            'La solicitud fue rechazada por comprobante repetido.',
          );
          this.closeModal();
        },
        error: () => {
          // El http-error.interceptor muestra el toast con el mensaje del backend.
          this.isLoadingButton = false;
        },
      });
  }

  //SWITCHES
  manualSwitch() {
    this.isManual = !this.isManual;
    this.validatorsReciptImg();
    this.reciptError = false;
    localStorage.setItem('isManual', String(this.isManual));
  }

  toggleAccountType(event: any): void {
    this.isSaving = !this.isSaving;
    this.accountTypeLabel = this.isSaving
      ? ACCOUNT_TYPES_TEXT.SAVINGS
      : ACCOUNT_TYPES_TEXT.CURRENT;
  }

  //*NG-SELECT
  async onBankSelected(event: any) {
    this.selectedBankId = event.value;

    if (this.isInterbankTransaction) {
      const interbankTransferType = this.cwEditForm.get(
        'transferencia_interbancaria',
      )?.value;

      if (
        interbankTransferType ===
          INTERBANK_TRANSDFER_OPTIONS_VALUES.YES.toString() ||
        interbankTransferType ===
          INTERBANK_TRANSDFER_OPTIONS_VALUES.OTHERS.toString()
      ) {
        this.selectedBankId =
          this.cwEditForm.get('id_banco_empresa')?.value || this.selectedBankId;
      } else if (
        interbankTransferType ===
        INTERBANK_TRANSDFER_OPTIONS_VALUES.NO.toString()
      ) {
        this.selectedBankId = this.cwEditForm.get('id_banco')?.value;
        this.cwEditForm.get('id_titular')?.setValue(null);
      }
    } else {
      if (this.cwEditForm.get('id_banco')?.value) {
        this.selectedBankId = this.cwEditForm.get('id_banco')?.value;
        this.cwEditForm.get('id_titular')?.setValue(null);
      }
    }

    if (this.selectedBankId) {
      const normalizedBankId = Number(this.selectedBankId);
      if (
        this.lastResolvedHolderBankId === normalizedBankId &&
        this.allHoldersData.length > 0
      ) {
        this.toggleTitularControl();
        return;
      }
      await this.loadHolders();
      this.lastResolvedHolderBankId = normalizedBankId;
      this.toggleTitularControl();
    } else {
      this.cwEditForm.get('id_titular')?.disable();
      this.lastResolvedHolderBankId = null;
    }
  }

  async onScrollToEnd() {
    this.currentPageHolders++;
    this.currentPageBanks++;
    this.getBankData(this.criteria);
    await this.loadHolders(this.criteria);
  }

  onSearch(term: string) {
    this.criteria = term;
    this.allHoldersData = [];
    this.allClientBankData = [];
    this.allEnterpriseBankData = [];
    this.currentPageHolders = PAGE_SIZE_VALUE;
    this.currentPageBanks = PAGE_SIZE_VALUE;
    this.holderSubject.next(term);
  }

  onSearchBank() {
    this.selectedBankId = DEFAULT_VALUE;
  }

  //*!ALERTS
  clearDangerAlerts(): void {
    this.alerts = this.alerts.filter(
      (alert) => alert.type !== ALERTS_TYPES.DANGER,
    );
  }

  showDangerAlert(message: string): void {
    this.alerts.push({ type: ALERTS_TYPES.DANGER, message: message });
  }

  closeAlert(alert: Alert): void {
    this.alerts.splice(this.alerts.indexOf(alert), 1);
  }

  watchFormChanges(): void {
    this.cwEditForm.get('comprobante')?.valueChanges.subscribe((val) => {
      if (val) {
        this.clearDangerAlerts();
      }
    });
  }

  //* IMAGES
  triggerFileInput(event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    if (this.isWithdrawalReceiptLocked()) {
      this.showBlockedReceiptChangeMessage();
      return;
    }
    this.fileInput.nativeElement.click();
  }
  async onFileSelected(event: any) {
    if (this.isWithdrawalReceiptLocked()) {
      this.showBlockedReceiptChangeMessage();
      event.target.value = '';
      return;
    }

    const file: File = event.target.files[0];

    if (file) {
      if (!file.type.startsWith('image/')) {
        this._toastrSvc.error('Solo se permiten imágenes en formato JPG o PNG');
        return;
      }

      try {
        const compressedFile =
          await this._imageCompressionService.compressImage(file);
        const url = this.fileUrl(compressedFile);

        this.selectedFiles = [
          {
            file: compressedFile,
            previewVisible: true,
            urlFile: url,
          },
        ];
        this.previewImage = url;
        this.processFile(compressedFile);
        event.target.value = '';
      } catch (error) {
        this._toastrSvc.error('Error al comprimir la imagen');
      }
    }
  }

  isInvalidFileType(url: string): boolean {
    const invalidExtensions = ['pdf', 'docx', 'doc'];
    const fileExtension = url.split('.').pop()?.toLowerCase();
    return invalidExtensions.includes(fileExtension || '');
  }

  /**
   * The backend masks the identification when the user lacks the sensitive-data
   * permission. Typing over it can't be saved (masked values are dropped), so the
   * field is locked instead of silently discarding the change.
   */
  get isIdentificationMasked(): boolean {
    const value = this.cwEditForm?.get('identificacion')?.value;
    return typeof value === 'string' && value.includes('***');
  }

  validateField(event: any, fieldName: string): void {
    const value = event.target.value;
    const regex = /^[a-zA-Z0-9-]*$/;

    if (fieldName === 'identificacion') {
      // A masked value (returned by the backend without the sensitive-data permission) is not validated.
      this.identificationError = !value.includes('***') && !regex.test(value);
    }
    if (fieldName === 'numero_cuenta') {
      this.numberAccountError = !regex.test(value);
    }
  }

  processFile(file: File) {
    const reader = new FileReader();
    reader.onload = async (event) => {
      if (event.target) {
        const imageData = event.target.result as string;
        this.processImage(imageData);

        const currentTransactionType = Number(
          this.cwEditForm.get('tipo_transaccion')?.value ??
            this.cwData?.tipo_transaccion,
        );

        if (
          !this.isManual &&
          !this.shouldSkipOcrForTransaction(currentTransactionType)
        ) {
          this.isLoadingButton = true;
          this.reciptError = false;

          const isWithdrawType = [
            TRANSACTION_TYPE_VALUES.WITHDRAW_BALANCE,
            TRANSACTION_TYPE_VALUES.COLLECT_COMMISSION,
            TRANSACTION_TYPE_VALUES.FINANCIAL,
          ].includes(currentTransactionType);

          this.cwEditForm.patchValue({
            [isWithdrawType ? 'comprobante_empresa' : 'comprobante']:
              PROCESSING_TEXT,
            detalle: PROCESSING_TEXT,
          });

          try {
            this.ocrService.extractData(file, DEFAULT_ATTEMPS).subscribe({
              next: (res: OcrResponse) => {
                showOcrPartialWarning(this._toastrSvc, res);

                if (res.data) {
                  const data = res.data;

                  const receiptValue =
                    data.id_comprobante?.toString().replace(/\s+/g, '') ?? null;
                  this.receipVoucher = receiptValue;

                  if (isWithdrawType) {
                    this.cwEditForm.patchValue({
                      comprobante_empresa: receiptValue,
                    });
                  } else {
                    this.cwEditForm.patchValue({ comprobante: receiptValue });
                  }

                  const sanitizedOcrDetail = this.getSanitizedOcrDetail(
                    data.detalle,
                    data.beneficiario,
                    !!data.detalle_riesgoso,
                  );
                  const patchData: Record<string, unknown> = {
                    detalle: sanitizedOcrDetail,
                    nombre_remitente: data.nombre_remitente?.toString().trim() || null,
                    origen_comprobante_bot:
                      data.origen_comprobante_bot?.toString().trim() || null,
                  };

                  if (
                    currentTransactionType !==
                    TRANSACTION_TYPE_VALUES.WITHDRAW_BALANCE
                  ) {
                    patchData.nombre_titular =
                      data.beneficiario?.toString().trim() || null;
                  }

                  this.cwEditForm.patchValue(patchData);

                  if (
                    currentTransactionType ===
                    TRANSACTION_TYPE_VALUES.FINANCIAL
                  ) {
                    this.applyEnterpriseBankFromOcr(data);
                  } else {
                    this.applyInterbankDataFromOcr(
                      data,
                      currentTransactionType,
                    );
                  }
                  this.applyRiskyFlagFromOcr(data);
                }
                this.isLoadingButton = false;
                this.validatorsReciptImg();
              },
              error: () => {
                this.isLoadingButton = false;
                this._toastrSvc.error('No se pudo procesar la imagen con IA');
                this.cwEditForm.patchValue({
                  [isWithdrawType ? 'comprobante_empresa' : 'comprobante']: '',
                  detalle: null,
                });
              },
            });
          } catch {
            this.isLoadingButton = false;
            this._toastrSvc.error('Error al preparar la imagen');
          }
        }
      }
    };
    reader.readAsDataURL(file);
  }

  shouldSkipOcrForTransaction(transactionType: number): boolean {
    return [
      TRANSACTION_TYPE_VALUES.CREDIT_DEPOSIT,
      TRANSACTION_TYPE_VALUES.CREDIT_WITHDRAWAL,
    ].includes(transactionType);
  }

  private applyRiskyFlagFromOcr(data: BankData): void {
    if (!data?.detalle_riesgoso) return;

    this.cwEditForm.patchValue(
      {
        estado_boleta_riesgosa: true,
        estado_revisar_boleta: false,
        cargar_retirar_directo: false,
      },
      { emitEvent: false },
    );
  }

  private normalizeRiskyText(value: string): string {
    return value
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  private normalizeForComparison(value: string): string {
    return this.normalizeRiskyText(value)
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  private looksLikePersonNameLine(normalizedLine: string): boolean {
    if (!normalizedLine) return false;

    const tokens = normalizedLine.split(' ').filter(Boolean);
    if (tokens.length < 2 || tokens.length > 6) return false;

    const isOnlyWords = tokens.every((token) => /^[a-z]+$/.test(token));

    const hasNonNameKeyword = tokens.some((token) =>
      NON_NAME_KEYWORDS.includes(token),
    );
    return !hasNonNameKeyword;
  }

  private getSanitizedOcrDetail(
    detalle: string | null | undefined,
    beneficiario?: string | null,
    hasRiskyContent: boolean = false,
  ): string | null {
    if (!detalle) return null;

    const rawDetail = String(detalle).trim();
    if (!rawDetail) return null;

    const detailLines = rawDetail
      .split('\n')
      .map((line) => line.trim())
      .filter(Boolean);
    const normalizedBeneficiary = beneficiario
      ? this.normalizeForComparison(String(beneficiario))
      : '';

    const filteredLines = detailLines.filter((line) => {
      const normalizedLine = this.normalizeForComparison(line);
      if (!normalizedLine) return false;

      if (GENERIC_LABELS.some((label) => normalizedLine.startsWith(label))) {
        return false;
      }

      if (
        normalizedBeneficiary &&
        (normalizedLine === normalizedBeneficiary ||
          normalizedLine.includes(normalizedBeneficiary))
      ) {
        return false;
      }

      if (this.looksLikePersonNameLine(normalizedLine)) {
        return false;
      }

      return true;
    });

    const sanitizedDetail = filteredLines.join('\n').trim();
    if (!sanitizedDetail) return null;

    const normalizedDetail = this.normalizeForComparison(sanitizedDetail);

    if (GENERIC_LABELS.some((label) => normalizedDetail.startsWith(label))) {
      return null;
    }

    if (
      normalizedBeneficiary &&
      (normalizedDetail === normalizedBeneficiary ||
        normalizedDetail.includes(normalizedBeneficiary))
    ) {
      return null;
    }

    const isDeunaDetail = normalizedDetail.includes(
      DETAIL_NORMALIZE.DEUNA_RECEIPT,
    );
    const isPeigoDetail = normalizedDetail.includes(DETAIL_NORMALIZE.PEIGO);

    if (!isDeunaDetail && !isPeigoDetail && !hasRiskyContent) {
      return null;
    }

    return sanitizedDetail;
  }

  // Regla aislada para Financiero: SOLO completa Banco Empresa segun el banco
  // detectado en el comprobante subido. No toca Banco Cliente, interbancaria,
  // ni la visibilidad de la seccion (a diferencia de applyInterbankDataFromOcr,
  // que esta pensado para el flujo normal de retiros/cargas).
  private async applyEnterpriseBankFromOcr(
    data: OcrResponse['data'],
  ): Promise<void> {
    let matchedEnterpriseBankId: number | null = null;
    if (data?.id_banco) {
      matchedEnterpriseBankId = data.id_banco;
    } else if (data?.banco_nombre) {
      const bankOption = this._bankMatcher.findBestMatch(
        data.banco_nombre,
        this.allClientBankData,
      );
      matchedEnterpriseBankId = bankOption?.value ?? null;
    }

    if (matchedEnterpriseBankId) {
      this.cwEditForm
        .get('id_banco_empresa')
        ?.setValue(matchedEnterpriseBankId, { emitEvent: false });

      // loadHolders() filtra por this.selectedBankId; sin esto la lista de
      // titulares queda mostrando todos los bancos en vez de filtrarse al
      // banco empresa recien detectado.
      this.selectedBankId = matchedEnterpriseBankId;
      const normalizedBankId = Number(matchedEnterpriseBankId);
      if (
        this.lastResolvedHolderBankId !== normalizedBankId ||
        this.allHoldersData.length === 0
      ) {
        await this.loadHolders();
        this.lastResolvedHolderBankId = normalizedBankId;
      }
      this.toggleTitularControl();
    }
  }

  private applyInterbankDataFromOcr(
    data: OcrResponse['data'],
    currentTransactionType: number,
  ): void {
    if (
      !this.isTransactionTypeAllowed(
        currentTransactionType,
        ALLOWED_TYPES_FOR_RECEIPT,
      )
    ) {
      return;
    }

    const interbankValue =
      typeof data?.interbank_transfer === 'number'
        ? data.interbank_transfer
        : data?.transferencia_interbancaria === true
          ? INTERBANK_TRANSDFER_OPTIONS_VALUES.YES
          : data?.transferencia_interbancaria === false
            ? INTERBANK_TRANSDFER_OPTIONS_VALUES.NO
            : null;

    let matchedClientBankId: number | null = null;
    if (data?.id_banco) {
      matchedClientBankId = data.id_banco;
    } else if (data?.banco_nombre) {
      const bankOption = this._bankMatcher.findBestMatch(
        data.banco_nombre,
        this.allClientBankData,
      );
      matchedClientBankId = bankOption?.value ?? null;
    }

    const matchedEnterpriseBankId = data?.id_banco_empresa ?? null;
    const hasSameSourceAndTargetBank =
      matchedClientBankId !== null &&
      matchedEnterpriseBankId !== null &&
      Number(matchedClientBankId) === Number(matchedEnterpriseBankId);

    const isInterbankOption = [
      INTERBANK_TRANSDFER_OPTIONS_VALUES.YES,
      INTERBANK_TRANSDFER_OPTIONS_VALUES.OTHERS,
    ]
      .map(String)
      .includes(String(interbankValue));

    const normalizedBanks = this.normalizeRiskyText(
      `${data?.banco_nombre ?? ''} ${data?.banco_cliente_nombre ?? ''} ${data?.banco_empresa_nombre ?? ''}`,
    );
    const detailNormalized = this.normalizeRiskyText(data?.detalle ?? '');
    const isDeunaPichinchaReceipt =
      detailNormalized.includes(DETAIL_NORMALIZE.DEUNA_RECEIPT) &&
      normalizedBanks.includes(DETAIL_NORMALIZE.PICHINCHA);

    const normalizedInterbankValue =
      isInterbankOption &&
      (hasSameSourceAndTargetBank || isDeunaPichinchaReceipt)
        ? INTERBANK_TRANSDFER_OPTIONS_VALUES.NO
        : interbankValue;

    this.isOcrAutoFilling = true;

    if (normalizedInterbankValue !== null) {
      this.cwEditForm
        .get('transferencia_interbancaria')
        ?.setValue(String(normalizedInterbankValue), { emitEvent: false });
    }

    if (matchedClientBankId) {
      this.cwEditForm.get('id_banco')?.setValue(matchedClientBankId, {
        emitEvent: false,
      });
    }

    if (
      [
        INTERBANK_TRANSDFER_OPTIONS_VALUES.YES,
        INTERBANK_TRANSDFER_OPTIONS_VALUES.OTHERS,
      ]
        .map(String)
        .includes(String(normalizedInterbankValue)) &&
      data?.id_banco_empresa
    ) {
      this.cwEditForm.get('id_banco_empresa')?.setValue(data.id_banco_empresa, {
        emitEvent: false,
      });
    } else if (matchedClientBankId) {
      this.cwEditForm.get('id_banco_empresa')?.setValue(matchedClientBankId, {
        emitEvent: false,
      });
    }

    this.transfer_Type = this.cwEditForm.get(
      'transferencia_interbancaria',
    )?.value;
    this.alloweEnterprise =
      this.transfer_Type ===
        INTERBANK_TRANSDFER_OPTIONS_VALUES.YES.toString() ||
      this.transfer_Type ===
        INTERBANK_TRANSDFER_OPTIONS_VALUES.OTHERS.toString();

    this.isOcrAutoFilling = false;
    this.updateTitularFieldState();

    if (matchedClientBankId) {
      this.onBankSelected({ value: matchedClientBankId });
    }
  }

  fileUrl(file: File): any {
    const url = URL.createObjectURL(file);
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  formatUrl(url: string) {
    const normalizedUrl = url.replace(/\\/g, '/').trim();

    if (/^https?:\/\//i.test(normalizedUrl)) {
      return normalizedUrl;
    }

    const uploadsIndex = normalizedUrl.indexOf('uploads/');
    const publicPath =
      uploadsIndex >= 0 ? normalizedUrl.slice(uploadsIndex) : normalizedUrl;

    return this.baseUrl + '/' + publicPath.replace(/ /g, '%20');
  }

  uploadFiles(files: FileList) {
    if (files.length > 0) {
      const file = files[0];

      if (!file.type.startsWith('image/')) {
        this._toastrSvc.error('Solo se permiten imágenes en formato JPG o PNG');
        return;
      }

      const url = this.fileUrl(file);

      this.selectedFiles = [
        {
          file: file,
          previewVisible: true,
          urlFile: url,
        },
      ];
    }
  }

  onDrop($event: DragEvent) {
    $event.preventDefault();
    if (this.isWithdrawalReceiptLocked()) {
      this.showBlockedReceiptChangeMessage();
      return;
    }
    const files = $event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.uploadFiles(files);
      this.processFile(files[0]);
    }
  }

  onDragOver($event: DragEvent) {
    $event.preventDefault();
  }

  removeImage() {
    if (this.isWithdrawalReceiptLocked()) {
      this.showBlockedReceiptChangeMessage();
      return;
    }
    this.previewImage = undefined;
  }

  processImage(imageData: string | ArrayBuffer | null) {
    if (imageData) {
      this.previewImage = imageData.toString();
    }
  }

  //* FORM
  initForm(): void {
    this.cwEditForm = this.fb.group({
      tipo_transaccion: [null, Validators.required],
      monto: [null],
      id_banco: [null],
      id_banco_empresa: [null],
      id_titular: [null],
      comprobante: ['', [Validators.pattern(/^[a-zA-Z0-9]*$/)]],
      comprobante_empresa: [''],
      nombre_titular: [null],
      nombre_remitente: [null],
      origen_comprobante_bot: [null],
      transferencia_interbancaria: [null],
      detalle: [null],
      identificacion: [null],
      numero_cuenta: [null],
      estado_revisar_boleta: false,
      permitirComprobante: false,
      cargar_retirar_directo: false,
      estado_boleta_riesgosa: false,
      estado_tiempo_espera: false,
    });

    this.loadProfileLogged();
    this.updateFileRequirement(this.cwEditForm.get('tipo_transaccion')?.value);
    this.cwEditForm.get('tipo_transaccion')?.valueChanges.subscribe((value) => {
      this.updateTransactionValidators(value, this.tipo_usuario);
      this.updateFileRequirement(value);
    });

    this.cwEditForm.get('id_banco_empresa')?.valueChanges.subscribe(() => {
      this.toggleTitularControl();
    });

    this.cwEditForm.get('tipo_transaccion')?.valueChanges.subscribe(() => {
      this.toggleTitularControl();
    });

    this.cwEditForm
      .get('transferencia_interbancaria')
      ?.valueChanges.subscribe(() => {
        this.transfer_Type = this.cwEditForm.get(
          'transferencia_interbancaria',
        )?.value;
        this.alloweEnterprise =
          this.transfer_Type ===
            INTERBANK_TRANSDFER_OPTIONS_VALUES.YES.toString() ||
          this.transfer_Type ===
            INTERBANK_TRANSDFER_OPTIONS_VALUES.OTHERS.toString();
        this.cwEditForm.get('id_titular')?.setValue(null);
        this.toggleTitularControl();
      });

    this.cwEditForm
      .get('transferencia_interbancaria')
      ?.valueChanges.subscribe(() => {
        if (this.isOcrAutoFilling) return;
        const transferencia_interbancaria = this.cwEditForm.get(
          'transferencia_interbancaria',
        )?.value;

        if (
          transferencia_interbancaria ===
          INTERBANK_TRANSDFER_OPTIONS_VALUES.YES.toString()
        ) {
          this.checkBankEquality();
        }
      });

    this.cwEditForm.get('id_banco')?.valueChanges.subscribe((value) => {
      const transferencia_interbancaria = this.cwEditForm.get(
        'transferencia_interbancaria',
      )?.value;
      if (
        transferencia_interbancaria ===
          INTERBANK_TRANSDFER_OPTIONS_VALUES.NO.toString() ||
        transferencia_interbancaria ===
          INTERBANK_TRANSDFER_OPTIONS_VALUES.OTHERS.toString()
      ) {
        this.cwEditForm.get('id_banco_empresa')?.setValue(value);
      }
    });

    this.cwEditForm.get('id_banco')?.valueChanges.subscribe(() => {
      this.updateTitularFieldState();
    });

    this.cwEditForm.get('id_banco_empresa')?.valueChanges.subscribe(() => {
      this.updateTitularFieldState();
    });
  }

  updateFileRequirement(transactionType: string): void {
    this.isFileRequired = [
      TRANSACTION_TYPE_VALUES.LOAD_BALANCE.toString(),
      TRANSACTION_TYPE_VALUES.PAY_TO_DEBIT.toString(),
      TRANSACTION_TYPE_VALUES.WITHDRAW_BALANCE.toString(),
      TRANSACTION_TYPE_VALUES.CREDIT_DEPOSIT.toString(),
      TRANSACTION_TYPE_VALUES.CREDIT_WITHDRAWAL.toString(),
    ].includes(transactionType);
    this.cwEditForm.get('foto_comprobante')?.updateValueAndValidity();
  }

  isRequiredImageMissing(): boolean {
    if (!this.isFileRequired) return false;

    const hasUploadedImage = this.selectedFiles.length > DEFAULT_VALUE;
    const hasValidCurrentImage =
      !!this.previewImage && !this.isInvalidFileType(this.previewImage);

    return !hasUploadedImage && !hasValidCurrentImage;
  }

  getSelectedTransactionLabel(): string {
    const transactionType = this.cwEditForm.get('tipo_transaccion')?.value;
    const selectedType = TRANSACTION_TYPES.find(
      (item) => item.value === String(transactionType),
    );

    return selectedType?.label || 'este tipo de transacción';
  }

  getRequiredImageMessage(): string {
    return `¡Recuerda que la imagen en ${this.getSelectedTransactionLabel()} es obligatoria!`;
  }

  updateTitularFieldState(): void {
    const bancoCliente = this.cwEditForm.get('id_banco')?.value;
    const bancoEmpresa = this.cwEditForm.get('id_banco_empresa')?.value;

    if (bancoCliente || bancoEmpresa) {
      this.cwEditForm.get('id_titular')?.enable();
    } else {
      this.cwEditForm.get('id_titular')?.disable();
      this.cwEditForm.get('id_titular')?.setValue(null);
    }
  }

  convertBooleanFieldsToNumbers(data: any): any {
    const convertedData = { ...data };
    const fieldsToConvert = [
      'estado_revisar_boleta',
      'permitirComprobante',
      'estado_boleta_riesgosa',
    ];

    fieldsToConvert.forEach((field) => {
      if (convertedData[field] === true) {
        convertedData[field] = TRUE_CHECK_VALUE;
      } else {
        convertedData[field] = DEFAULT_VALUE;
      }
    });

    return convertedData;
  }

  onSubmit(afterSave?: () => void) {
    this.markFormGroupTouched(this.cwEditForm);
    this.checkFormStatus();
    this.setDefaultValues();
    const transferencia_interbancaria = this.cwEditForm.get(
      'transferencia_interbancaria',
    )?.value;
    if (
      transferencia_interbancaria ===
        INTERBANK_TRANSDFER_OPTIONS_VALUES.YES.toString() ||
      transferencia_interbancaria ===
        INTERBANK_TRANSDFER_OPTIONS_VALUES.OTHERS.toString()
    ) {
      const idBankValue = this.cwEditForm.get('id_banco_empresa')?.value;
      const voucherValue = this.cwEditForm.get('comprobante_empresa')?.value;
      this.cwEditForm.get('id_banco_empresa')?.setValue(idBankValue);
      this.cwEditForm.get('comprobante_empresa')?.setValue(voucherValue);
    } else {
      this.cwEditForm.get('id_banco_empresa')?.setValue(0);
      this.cwEditForm.get('comprobante_empresa')?.setValue('');
    }

    if (
      !(
        this.cwData.tipo_transaccion ===
          TRANSACTION_TYPE_VALUES.WITHDRAW_BALANCE ||
        this.cwData.tipo_transaccion ===
          TRANSACTION_TYPE_VALUES.COLLECT_COMMISSION ||
        this.cwData.tipo_transaccion ===
          TRANSACTION_TYPE_VALUES.WITHDRAW_RISK_VOUCHER
      )
    ) {
      if (this.checkBankEquality()) {
        return;
      }
    }

    let cwRequestData = this.cwEditForm.value;

    if (this.isWithdrawalReceiptLocked() && this.selectedFiles.length > 0) {
      this.showBlockedReceiptChangeMessage();
      return;
    }

    const errorMessages: { [key: string]: string } = {
      [TRANSACTION_TYPE_VALUES.LOAD_BALANCE]: ERROR_MESSAGES.LOAD_BALANCE,
      [TRANSACTION_TYPE_VALUES.PAY_TO_DEBIT]:
        'La foto del comprobante es obligatoria para la transacción de Abonar a Deuda.',
      [TRANSACTION_TYPE_VALUES.WITHDRAW_BALANCE]:
        ERROR_MESSAGES.WITHDRAW_BALANCE,
      [TRANSACTION_TYPE_VALUES.CREDIT_DEPOSIT]: ERROR_MESSAGES.CREDIT_DEPOSIT,
      [TRANSACTION_TYPE_VALUES.CREDIT_WITHDRAWAL]:
        ERROR_MESSAGES.CREDIT_WITHDRAWAL,
    };

    if (this.isRequiredImageMissing()) {
      const errorMessage = errorMessages[cwRequestData.tipo_transaccion];
      this._toastrSvc.error(errorMessage);
      return;
    }

    cwRequestData.tipo_cuenta = this.isSaving
      ? ACCOUNT_TYPES.SAVINGS
      : ACCOUNT_TYPES.CURRENT;

    if (this.cwEditForm.valid) {
      cwRequestData = this.convertBooleanFieldsToNumbers(cwRequestData);
      this.isLoadingButton = true;

      if (
        [
          TRANSACTION_TYPE_VALUES.CREDIT_DEPOSIT.toString(),
          TRANSACTION_TYPE_VALUES.CREDIT_WITHDRAWAL.toString(),
        ].includes(cwRequestData.tipo_transaccion)
      ) {
        cwRequestData.id_banco = cwRequestData.id_banco || DEFAULT_VALUE;
        cwRequestData.id_banco_empresa =
          cwRequestData.id_banco_empresa || DEFAULT_VALUE;
        cwRequestData.id_titular = cwRequestData.id_titular || DEFAULT_VALUE;
      }

      this.sendFormData(cwRequestData, afterSave);
    } else {
      this._toastrSvc.error(
        'Rellena todo el formulario o verifica el monto mínimo!',
      );
      this.isLoadingButton = false;
    }
  }

  sendFormData(cwRequestData: any, afterSave?: () => void) {
    const formData = new FormData();

    formData.append('tipo_transaccion', cwRequestData.tipo_transaccion);
    formData.append('id', this.data.id.toString());
    formData.append('id_banco', cwRequestData.id_banco);
    const transferenciaInterbancaria =
      cwRequestData.transferencia_interbancaria;
    if (
      transferenciaInterbancaria === INTERBANK_TRANSDFER_OPTIONS_VALUES.NO ||
      transferenciaInterbancaria === INTERBANK_TRANSDFER_OPTIONS_VALUES.OTHERS
    ) {
      formData.append('id_banco_empresa', cwRequestData.id_banco);
    } else {
      if (
        cwRequestData.id_banco_empresa !== undefined &&
        cwRequestData.id_banco_empresa !== null
      ) {
        formData.append('id_banco_empresa', cwRequestData.id_banco_empresa);
      } else if (this.cwData.id_banco_empresa) {
        formData.append(
          'id_banco_empresa',
          this.cwData.id_banco_empresa.toString(),
        );
      } else {
        formData.append('id_banco_empresa', DEFAULT_VALUE.toString());
      }
    }
    if (
      this.cwData.tipo_transaccion ===
        TRANSACTION_TYPE_VALUES.WITHDRAW_BALANCE ||
      this.cwData.tipo_transaccion ===
        TRANSACTION_TYPE_VALUES.COLLECT_COMMISSION
    ) {
      formData.append('comprobante', '');
    } else {
      formData.append('comprobante', (cwRequestData.comprobante || '').trim());
    }
    formData.append(
      'comprobante_empresa',
      (cwRequestData.comprobante_empresa || '').trim(),
    );
    formData.append(
      'identificacion',
      (cwRequestData.identificacion || '').trim(),
    );
    formData.append('detalle', cwRequestData.detalle);
    formData.append('id_usuario_set', this.profile.idusuario);
    formData.append('nombre_titular', cwRequestData.nombre_titular);
    formData.append('nombre_remitente', cwRequestData.nombre_remitente || '');
    formData.append(
      'origen_comprobante_bot',
      cwRequestData.origen_comprobante_bot || '',
    );
    if (
      cwRequestData.id_titular !== undefined &&
      cwRequestData.id_titular !== null
    ) {
      formData.append('id_titular', cwRequestData.id_titular);
    } else if (this.cwData.id_titular) {
      formData.append('id_titular', this.cwData.id_titular.toString());
    } else {
      formData.append('id_titular', DEFAULT_VALUE.toString());
    }
    formData.append(
      'transferencia_interbancaria',
      cwRequestData.transferencia_interbancaria,
    );

    if (
      this.data?.isCorrectionEdit &&
      this.cwData.estado === STATE_NAMES.CORRECTION
    ) {
      formData.append('estado', this.cwData.estado_anterior);
      formData.append('estado_anterior', this.cwData.estado);
    } else {
      formData.append('estado', this.data.estado);
    }
    formData.append('estado_revisar_boleta', this.cwData.estado_revisar_boleta);
    formData.append('estado_tiempo_espera', cwRequestData.estado_tiempo_espera);
    formData.append('permitirComprobante', cwRequestData.permitirComprobante);
    formData.append(
      'estado_boleta_riesgosa',
      cwRequestData.estado_boleta_riesgosa,
    );
    formData.append(
      'numero_cuenta',
      (cwRequestData.numero_cuenta || '').trim(),
    );
    formData.append('tipo_cuenta', cwRequestData.tipo_cuenta);
    if (this.selectedFiles.length > DEFAULT_VALUE) {
      formData.append(
        'foto_comprobante',
        this.selectedFiles[DEFAULT_VALUE].file,
      );
    } else if (this.recipt) {
      formData.append('foto_comprobante', this.recipt);
    } else {
      formData.append('foto_comprobante', '');
    }
    this._toastrSvc.info('Procesando...');
    this._cwService.setRequest(formData).subscribe(
      (response) => {
        this._toastrSvc.success('Solicitud editada correctamente!.');
        if (afterSave) {
          afterSave();
          return;
        }
        this.isLoadingButton = false;
        this.closeModal();
      },
      (err) => {
        this.isLoadingButton = false;
        this._toastrSvc.error('Error al enviar el formulario.');
      },
    );
  }

  setDefaultValues(): void {
    // Para Financiero estos campos son obligatorios (Validators.required).
    // required no rechaza 0, asi que si los completamos con DEFAULT_VALUE
    // (0) aca, la validacion nunca dispara aunque el campo este realmente
    // vacio. Se saltea el default para Financiero para que el required
    // funcione de verdad.
    if (this.cwData?.tipo_transaccion === TRANSACTION_TYPE_VALUES.FINANCIAL) {
      return;
    }

    const fields = ['id_banco', 'id_banco_empresa', 'id_titular'];
    fields.forEach((field) => {
      const control = this.cwEditForm.get(field);
      if (!control?.value) {
        control?.setValue(DEFAULT_VALUE);
      }
    });
  }

  validatorsReciptImg() {
    const userEnteredReceipt = this.cwEditForm.get('comprobante')?.value;
    const imageReceipt = this.receipVoucher;
    if (userEnteredReceipt !== imageReceipt && !this.isManual) {
      this.reciptError = true;
    } else {
      this.reciptError = false;
    }
  }

  isWithdrawalReceiptLocked(): boolean {
    const isWithdrawalType =
      Number(this.cwData?.tipo_transaccion) ===
      TRANSACTION_TYPE_VALUES.WITHDRAW_BALANCE;
    const hasOriginalReceipt = Boolean(this.originalReceiptImage);

    return (
      isWithdrawalType &&
      hasOriginalReceipt &&
      !this.canOverrideProcessedWithdrawalReceipt()
    );
  }

  canShowRemoveImageButton(): boolean {
    return !this.isWithdrawalReceiptLocked();
  }

  private canOverrideProcessedWithdrawalReceipt(): boolean {
    return this.hasPermission(
      REQUEST_WITHDRAWAL_PERMISSIONS.OVERRIDE_WITHDRAWAL_RECEIPT,
    );
  }

  hasPermission(permissionId: number): boolean {
    return this.profile?.rol?.permisos_principales?.some(
      (permisoPrincipal: any) =>
        permisoPrincipal.permisos.some(
          (permiso: any) =>
            permiso.id === permissionId &&
            Number(permiso.activar) === GENERAL_STATUS.ACTIVE,
        ),
    );
  }

  private getReceiptOwnerName(): string {
    return (
      this.data?.updatedBy ||
      this.cwData?.updated_by?.nombres ||
      this.cwData?.updated_by?.usuario ||
      WITHDRAWAL_RECEIPT_LOCK.DEFAULT_OWNER_NAME
    );
  }

  private showBlockedReceiptChangeMessage(): void {
    const ownerName = this.getReceiptOwnerName();
    this._toastrSvc.warning(
      WITHDRAWAL_RECEIPT_LOCK.CHANGE_BLOCKED_MESSAGE.replace(
        '{{owner}}',
        ownerName,
      ),
    );
  }

  onKeyPress(event: KeyboardEvent) {
    const allowedKeys = ALLOW_KEYS;
    if (!allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  handleConfirmationRt() {
    const currentStatus = this.cwEditForm.get('estado_boleta_riesgosa')?.value;
    Swal.fire({
      title: '¿Estás seguro?',
      text: currentStatus
        ? '¿Estás seguro de marcar Boleta Riesgosa?'
        : '¿Estás seguro de desmarcar Boleta Riesgosa?',
      icon: 'warning',
      iconColor: '#8C98A1',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#54BA4A',
      cancelButtonColor: '#5A6268',
    }).then((result) => {
      if (result.isConfirmed) {
        const formControl = this.cwEditForm.get('estado_boleta_riesgosa');
        if (formControl) {
          formControl.setValue(currentStatus);
        }

        if (currentStatus) {
          this.cwEditForm.patchValue({
            estado_revisar_boleta: false,
          });
        }
      } else {
        this.cwEditForm.patchValue({
          estado_boleta_riesgosa: !currentStatus,
        });
      }
    });
  }

  handleConfirmationCr() {
    const currentStatus = this.cwEditForm.get('permitirComprobante')?.value;
    Swal.fire({
      title: '¿Estás seguro?',
      text: currentStatus
        ? '¿Estás seguro de marcar Permitir Comporbante Repetido?'
        : '¿Estás seguro de desmarcar Permitir Comporbante Repetido?',
      icon: 'warning',
      iconColor: '#8C98A1',
      showCancelButton: true,
      confirmButtonColor: '#54BA4A',
      cancelButtonColor: '#5A6268',
      confirmButtonText: 'Sí',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        const formControl = this.cwEditForm.get('permitirComprobante');
        if (formControl) {
          formControl.setValue(currentStatus);
        }
      } else {
        this.cwEditForm.patchValue({
          permitirComprobante: !currentStatus,
        });
      }
    });
  }

  handleConfirmationTe() {
    const currentStatus = this.cwEditForm.get('estado_tiempo_espera')?.value;
    Swal.fire({
      title: '¿Estás seguro?',
      text: currentStatus
        ? '¿Estás seguro de marcar Transacción en espera?'
        : '¿Estás seguro de desmarcar Transacción en espera?',
      icon: 'warning',
      iconColor: '#8C98A1',
      showCancelButton: true,
      confirmButtonColor: '#54BA4A',
      cancelButtonColor: '#5A6268',
      confirmButtonText: 'Sí',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        const formControl = this.cwEditForm.get('estado_tiempo_espera');
        if (formControl) {
          formControl.setValue(currentStatus);
        }
      } else {
        this.cwEditForm.patchValue({
          estado_tiempo_espera: !currentStatus,
        });
      }
    });
  }

  handleConfirmationRb() {
    const currentStatus = this.cwEditForm.get('estado_revisar_boleta')?.value;
    Swal.fire({
      title: '¿Estás seguro?',
      text: currentStatus
        ? '¿Estás seguro de marcar Revisar boleta?'
        : '¿Estás seguro de desmarcar Revisar boleta?',
      icon: 'warning',
      iconColor: '#8C98A1',
      showCancelButton: true,
      confirmButtonColor: '#54BA4A',
      cancelButtonColor: '#5A6268',
      confirmButtonText: 'Sí',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        const formControl = this.cwEditForm.get('estado_revisar_boleta');
        if (formControl) {
          formControl.setValue(currentStatus);
        }

        if (currentStatus) {
          this.cwEditForm.patchValue({
            estado_boleta_riesgosa: false,
          });
        }
      } else {
        this.cwEditForm.patchValue({
          estado_revisar_boleta: !currentStatus,
        });
      }
    });
  }

  handleCheckboxChange(checkboxName: string) {
    if (checkboxName === 'estado_boleta_riesgosa') {
      this.handleConfirmationRt();
    }
    if (checkboxName === 'estado_revisar_boleta') {
      this.handleConfirmationRb();
    }
    if (checkboxName === 'permitirComprobante') {
      this.handleConfirmationCr();
    }
    if (checkboxName === 'estado_tiempo_espera') {
      this.handleConfirmationTe();
    } else {
      const formControl = this.cwEditForm.get(checkboxName);

      if (formControl) {
        if (formControl.value) {
          if (checkboxName === 'estado_revisar_boleta') {
            this.cwEditForm.patchValue({
              estado_boleta_riesgosa: false,
            });
          } else if (checkboxName === 'estado_boleta_riesgosa') {
            this.cwEditForm.patchValue({
              estado_revisar_boleta: false,
            });
          }
        }
      }
    }
  }

  updateTransactionValidators(
    transactionType: string,
    tipo_usuario: string,
  ): void {
    if (this.updatingValidators) return;

    this.updatingValidators = true;

    if (this.cwData?.tipo_transaccion === TRANSACTION_TYPE_VALUES.FINANCIAL) {
      this.clearAllValidators();
      // Todos los campos visibles para Financiero son obligatorios excepto
      // Detalle (el unico sin asterisco en el formulario).
      this.setValidators(
        [
          'monto',
          'id_banco',
          'id_titular',
          'identificacion',
          'numero_cuenta',
          'id_banco_empresa',
          'comprobante_empresa',
          'nombre_titular',
        ],
        Validators.required,
      );
      this.cwEditForm.updateValueAndValidity();
      this.updatingValidators = false;
      return;
    }

    this.clearAllValidators();

    const validatorsRequired = Validators.required;

    if (
      [
        TRANSACTION_TYPE_VALUES.LOAD_BALANCE.toString(),
        TRANSACTION_TYPE_VALUES.LOAD_BONUS_BALANCE.toString(),
        TRANSACTION_TYPE_VALUES.PAY_TO_DEBIT.toString(),
      ].includes(transactionType)
    ) {
      this.setValidators(
        ['monto', 'id_banco', 'comprobante'],
        validatorsRequired,
      );
      if (tipo_usuario !== USER_TYPES.AGENT_LEVEL_ONE.toString()) {
        this.setValidators(
          ['id_agente', 'id_jugador', 'id_titular'],
          validatorsRequired,
        );
      }
    } else if (['1', '4'].includes(transactionType)) {
      this.setValidators(
        ['monto', 'id_banco', 'identificacion', 'numero_cuenta'],
        validatorsRequired,
      );
      if (tipo_usuario !== USER_TYPES.AGENT_LEVEL_ONE.toString()) {
        this.setValidators(
          ['id_agente', 'id_jugador', 'id_titular'],
          validatorsRequired,
        );
      }
    } else if (['6', '7'].includes(transactionType)) {
      this.setValidators(['monto'], validatorsRequired);
      if (tipo_usuario !== USER_TYPES.AGENT_LEVEL_ONE.toString()) {
        this.setValidators(['id_agente', 'id_jugador'], validatorsRequired);
      }
    }

    if (this.isDetailRequired(transactionType)) {
      this.setValidators(['detalle'], validatorsRequired);
    }

    this.cwEditForm.updateValueAndValidity();

    this.updatingValidators = false;
  }

  clearAllValidators(): void {
    Object.keys(this.cwEditForm.controls).forEach((key) => {
      this.cwEditForm.get(key)?.clearValidators();
      this.cwEditForm.get(key)?.updateValueAndValidity();
    });
  }

  setValidators(fields: string[], validator: ValidatorFn): void {
    fields.forEach((field) => {
      const control = this.cwEditForm.get(field);
      if (control) {
        control.setValidators(validator);
        control.updateValueAndValidity();
      }
    });
  }

  isDetailRequired(transactionType: string | number | null): boolean {
    return [
      TRANSACTION_TYPE_VALUES.PAY_TO_DEBIT,
      TRANSACTION_TYPE_VALUES.CREDIT_DEPOSIT,
      TRANSACTION_TYPE_VALUES.CREDIT_WITHDRAWAL,
    ]
      .map(String)
      .includes(String(transactionType));
  }

  checkFormStatus() {
    const invalidFields = [];
    const formControls = this.cwEditForm.controls;
    for (const name in formControls) {
      if (formControls[name].invalid) {
        invalidFields.push(name);
      }
    }
    if (invalidFields.length > DEFAULT_VALUE) {
    } else {
    }
  }

  checkBankEquality(): boolean {
    const transferencia_interbancaria = this.cwEditForm.get(
      'transferencia_interbancaria',
    )?.value;

    if (
      transferencia_interbancaria ===
        INTERBANK_TRANSDFER_OPTIONS_VALUES.YES.toString() &&
      ![
        TRANSACTION_TYPE_VALUES.CREDIT_WITHDRAWAL,
        TRANSACTION_TYPE_VALUES.CREDIT_DEPOSIT,
        TRANSACTION_TYPE_VALUES.WITHDRAW_BALANCE,
        TRANSACTION_TYPE_VALUES.FINANCIAL,
      ].includes(this.cwEditForm.get('tipo_transaccion')?.value)
    ) {
      const id_banco = this.cwEditForm.get('id_banco')?.value;
      const id_banco_empresa = this.cwEditForm.get('id_banco_empresa')?.value;
      if (id_banco === id_banco_empresa) {
        return true;
      }
    }
    return false;
  }

  isTitularEnabled(): boolean {
    const tipoTransaccion = this.cwEditForm.get('tipo_transaccion')?.value;
    const interbankTransfer = this.cwEditForm.get(
      'transferencia_interbancaria',
    )?.value;
    const isBankClientSelected = !!this.cwEditForm.get('id_banco')?.value;
    const isBankEnterpriseSelected =
      !!this.cwEditForm.get('id_banco_empresa')?.value;

    const isWithdrawTransaction = [
      TRANSACTION_TYPE_VALUES.WITHDRAW_BALANCE,
      TRANSACTION_TYPE_VALUES.COLLECT_COMMISSION,
      TRANSACTION_TYPE_VALUES.WITHDRAW_RISK_VOUCHER,
    ].includes(Number(tipoTransaccion));

    const isInterbankTransfer = [
      INTERBANK_TRANSDFER_OPTIONS_VALUES.YES,
      INTERBANK_TRANSDFER_OPTIONS_VALUES.OTHERS,
    ].includes(interbankTransfer);

    if (isWithdrawTransaction) {
      return isBankEnterpriseSelected;
    }

    if (isInterbankTransfer) {
      return isBankEnterpriseSelected;
    }

    return isBankClientSelected;
  }

  toggleTitularControl(): void {
    if (this.isTitularEnabled()) {
      this.cwEditForm.get('id_titular')?.enable();
    } else {
      this.cwEditForm.get('id_titular')?.disable();
    }
  }

  markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach((control) => {
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      } else {
        control.markAsTouched();
      }
    });
  }

  isTransactionTypeAllowed(
    transactionType: string | number,
    allowedTypes: (string | number)[],
  ): boolean {
    return allowedTypes.map(String).includes(String(transactionType));
  }

  isBankSelected(): boolean {
    return !!this.cwEditForm.get('id_banco')?.value;
  }

  get isInterbankTransaction(): boolean {
    const validInterbankOptions = [
      INTERBANK_TRANSDFER_OPTIONS_VALUES.YES,
      INTERBANK_TRANSDFER_OPTIONS_VALUES.OTHERS,
      INTERBANK_TRANSDFER_OPTIONS_VALUES.NO,
    ];

    return validInterbankOptions.includes(
      this.cwEditForm.get('transferencia_interbancaria')?.value,
    );
  }
}
